import { Link, usePage } from "@inertiajs/react";
import { Home, Mic, Calendar, Building2 } from "lucide-react";

const tabs = [
  { name: "ホーム", href: "/users", icon: Home },
  { name: "面接練習", href: "/users/interview_practices", icon: Mic },
  { name: "スケジュール", href: "/users/schedules", icon: Calendar },
  { name: "選考企業", href: "/users/companies", icon: Building2 },
];

export function BottomTabBar() {
  const { url } = usePage();

  const isActive = (href: string) => {
    if (href === "/users") return url === "/users" || url === "/users/welcome";
    return url.startsWith(href);
  };

  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 border-t border-border bg-background pb-[env(safe-area-inset-bottom)] lg:hidden">
      <div className="flex justify-around">
        {tabs.map((tab) => {
          const active = isActive(tab.href);
          return (
            <Link
              key={tab.name}
              href={tab.href}
              className={`flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${
                active
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <tab.icon className="size-5" strokeWidth={active ? 2.5 : 2} />
              <span>{tab.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
